import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class I18nContainer extends Component {
  render() {
    const { children, locale, localeMessage } = this.props;

    return (
      <IntlProvider key={locale} locale={locale} messages={localeMessage}>
        {children}
      </IntlProvider>
    )
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    locale: state.i18nReducers.locale,
    localeMessage: state.i18nReducers.localeMessage,
    status: state.i18nReducers.status
  }
}

export default withRouter(connect(
  mapStateToProps, 
  {}
)(I18nContainer))